//Module Keys
let locales = {};

//Merge Views

//Main
import mainView from "../../views/main/lan/en";
locales = { ...locales, ...mainView };

//Fuel Card Modals

import editManageFuelCard from "../../views/fuelCardTab/modals/editManageFuelCard/lan/en";
locales = { ...locales, ...editManageFuelCard };

//Crew Modals
import createEditManageCrew from "../../views/crewTab/modals/createEditManageCrew/lan/en";
locales = { ...locales, ...createEditManageCrew };

import deleteManageCrew from "../../views/crewTab/modals/deleteManageCrew/lan/en";
locales = { ...locales, ...deleteManageCrew };

//KeyFob Modals
import createEditManageKeyFob from "../../views/keyFobsTab/modals/createEditManageKeyFob/lan/en";
locales = { ...locales, ...createEditManageKeyFob };

import deleteManageKeyFob from "../../views/keyFobsTab/modals/deleteManageKeyFob/lan/en";
locales = { ...locales, ...deleteManageKeyFob };

//Temperature Modals
import createEditManageTemperature from "../../views/temperatureTab/modals/createEditManageTemperature/lan/en"
locales = { ...locales, ...createEditManageTemperature };

import deleteManageTemperature from "../../views/temperatureTab/modals/deleteManageTemperature/lan/en"
locales = { ...locales, ...deleteManageTemperature };

//Equipment Modals
import createEditEquipment from "../../views/equipmentTab/modals/createEditManageEquipment/lan/en";
locales = { ...locales, ...createEditEquipment };

import deleteEquipment from "../../views/equipmentTab/modals/deleteManageEquipment/lan/en";
locales = { ...locales, ...deleteEquipment };

//Driver Status Modals
import createEditDriverStatus from "../../views/driverStatusTab/modals/createEditManageDriverStatus/lan/en";
locales = { ...locales, ...createEditDriverStatus };

import deleteDriverStatus from "../../views/driverStatusTab/modals/deleteManageDriverStatus/lan/en";
locales = { ...locales, ...deleteDriverStatus };

//Locations
import createEditLocation from "../../views/locationsTab/modals/createEditManageLocation/lan/en";
locales = { ...locales, ...createEditLocation };
import deleteLocation from "../../views/locationsTab/modals/deleteManageLocation/lan/en";
locales = { ...locales, ...deleteLocation };

//Camera Management
import editCameraManagementCamera from "../../views/cameraManagementTab/modals/editCameraManagementCamera/lan/en";
locales = { ...locales, ...editCameraManagementCamera };
import editCameraManagementPairing from "../../views/cameraManagementTab/modals/editCameraManagementPairing/lan/en";
locales = { ...locales, ...editCameraManagementPairing };

//Behavior Modals
import createEditManageBehavior from "../../views/behaviorTab/modals/create/lan/en";
locales = { ...locales, ...createEditManageBehavior };
import deleteManageBehavior from "../../views/behaviorTab/modals/delete/lan/en";
locales = { ...locales, ...deleteManageBehavior };

//Vehicle Status Modals
import createEditManageVehicleStatus from "../../views/vehicleStatusTab/modals/createEditManageVehicleStatus/lan/en";
locales = { ...locales, ...createEditManageVehicleStatus };
import deleteManageVehicleStatus from "../../views/vehicleStatusTab/modals/deleteManageVehicleStatus/lan/en";
locales = { ...locales, ...deleteManageVehicleStatus };

//Inputs Modals
import createEditManageInput from "../../views/inputsTab/modals/createEditManageInput/lan/en";
locales = { ...locales, ...createEditManageInput };

import deleteManageInput from "../../views/inputsTab/modals/deleteManageInput/lan/en";
locales = { ...locales, ...deleteManageInput };

//Assets tab
import assetTab from "../../views/assetTab/lan/en";
locales = { ...locales, ...assetTab };

//Asset Subtype
import assetSubtype from "../../views/assetSubtype/lan/en";
locales = { ...locales, ...assetSubtype };

//Work Order Status
import workOrderStatus from "../../views/workOrderStatus/lan/en";
locales = { ...locales, ...workOrderStatus };

//Work Order Type
import workOrderType from "../../views/workOrderType/lan/en";
locales = { ...locales, ...workOrderType };

export default locales;
